import React, { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <nav className="nav">
        <div className="nav-container">
          <div className="nav-logo">
            <img src="/logo192.png" alt="Alium Software" className="logo-image" />
            <div className="logo-text-container">
              <span className="logo-text">Alium</span>
              <span className="logo-accent">Software</span>
            </div>
          </div>
          
          <ul className={`nav-menu ${isMenuOpen ? 'nav-menu-active' : ''}`}>
            <li className="nav-item">
              <a href="#home" className="nav-link" onClick={() => setIsMenuOpen(false)}>Home</a>
            </li>
            <li className="nav-item">
              <a href="#services" className="nav-link" onClick={() => setIsMenuOpen(false)}>Services</a>
            </li>
            <li className="nav-item">
              <a href="#about" className="nav-link" onClick={() => setIsMenuOpen(false)}>About</a>
            </li>
            <li className="nav-item">
              <a href="#contact" className="nav-link" onClick={() => setIsMenuOpen(false)}>Contact</a>
            </li>
            <li className="nav-item">
              <a href="#support" className="nav-link" onClick={() => setIsMenuOpen(false)}>Support</a>
            </li>
            <li className="nav-item">
              <a href="#privacy" className="nav-link" onClick={() => setIsMenuOpen(false)}>Privacy</a>
            </li>
          </ul>
          
          <button 
            className={`nav-toggle ${isMenuOpen ? 'nav-toggle-active' : ''}`} 
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;